/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import docApi from "api";
import { getShouldRenderEditDropin } from "selectors/overlayDropinSelectors";
import {
  getFileName,
  getFileExtension,
  getTitle,
  getAssetURI,
  getShouldRenderAcroForm,
  getAlternateAssetURI,
  isAlternateAssetURIAvailable
} from "selectors/documentSelectors";
import { isPersonalCommentingEnabled } from "utils/FeatureFlagUtils";
import { download, downloadUsingAssetURI } from "utils/FileDownloadUtility";
import { trackDownloadFileClicked } from "../analytics/events";
import { triggerDownloadEvent } from "publicApis/Events/events";
import { featureLifecyleHooks } from "constants/enums";
import { featureLifecycleHookController } from "publicApis/controller/featureLifecycleHookController";

const downloader = (data, fileSubtype, fileName, fileExtension) =>
  new Promise((resolve, reject) => {
    download(data, fileSubtype, fileName, fileExtension, docApi.getAssetUri()).then(
      () => {
        featureLifecycleHookController.trigger(featureLifecyleHooks.AFTER_DOWNLOAD, { success: true });
        resolve();
      },
      () => {
        featureLifecycleHookController.trigger(featureLifecyleHooks.AFTER_DOWNLOAD, { success: false });
        reject();
      }
    );
  });

export const downloadAssetFromDocApi = (stores, { triggeredFrom }) =>
  new Promise((resolve, reject) => {
    featureLifecycleHookController.trigger(featureLifecyleHooks.BEFORE_DOWNLOAD).then(() => {
      let fileSubtype = docApi.getFiletype();
      trackDownloadFileClicked(triggeredFrom);
      triggerDownloadEvent();
      if (isAlternateAssetURIAvailable(stores)) {
        downloadUsingAssetURI(getAlternateAssetURI(stores)).then(resolve, reject);
      } else {
        let fileName = getFileName(stores) || getTitle(stores);
        let fileExtension = getFileExtension(stores);
        if (
          docApi.getAJSMetaDataSucceeded() &&
          (getShouldRenderAcroForm(stores) || isPersonalCommentingEnabled(stores) || getShouldRenderEditDropin(stores))
        ) {
          return docApi.getContentBuffer().then(message => {
            downloader(message.data.buffer, fileSubtype, fileName, fileExtension).then(resolve, reject);
          }, reject);
        }
        return docApi
          .getFileBuffer()
          .then(data => {
            downloader(data, fileSubtype, fileName, fileExtension).then(resolve, reject);
          })
          .catch(reject);
      }
    }, reject);
  });
